import CompanyBenefit from 'models/CompanyBenefit';

import Component from './component';

export interface Props {
   headline: string;
   benefits: CompanyBenefit[];
   icon: string;
   iconAlt?: string;
}

Component.defaultProps = {};

export default Component;